import { render, staticRenderFns } from "./EmployeeInquiryDetail.vue?vue&type=template&id=51fc269c&"
import script from "./EmployeeInquiryDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeInquiryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports